import {gql} from '@apollo/react-hooks'

const AvailableGamesQuery = gql(`
query getAvailableGames {
    getAvailableGames(limit: 10000) {
      id
      RoundCurrent
      Player_1
      Player_2
      Player_3
      Player_4
    }
  }
`);

export default AvailableGamesQuery